import { Card, Form, Input, Radio } from 'antd';

export default function OwnershipSection({
  isMainlyStateCompany,
  setIsMainlyStateCompany,
  securitiesListedOnSecurityMarket,
  setSecuritiesListedOnSecurityMarket,
  securitiesListedOnReputableMarket,
  setSecuritiesListedOnReputableMarket,
  qt,
}) {
  return (
    <Card
      title={qt('questionnaire.ownershipStructureData')}
      className="mb-5"
      style={{ marginBottom: '20px' }}
    >
      {/* State Company Questions */}
      <Form.Item
        label={qt('questionnaire.isClientStateBody')}
        name="isStateCompany"
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group>
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        label={qt('questionnaire.isClientMajorityOwned')}
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group
          onChange={(e) => setIsMainlyStateCompany(e.target.value)}
          value={isMainlyStateCompany}
        >
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      {isMainlyStateCompany && (
        <Form.Item
          name="mainlyStateCompanySpecification"
          label={qt('questionnaire.specifyNameHeadquarter')}
          style={{ marginBottom: '15px' }}
        >
          <Input.TextArea rows={2} />
        </Form.Item>
      )}

      {/* Securities Market Questions */}
      <Form.Item
        label={qt('questionnaire.areSecuritiesMarket')}
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group
          onChange={(e) => setSecuritiesListedOnSecurityMarket(e.target.value)}
          value={securitiesListedOnSecurityMarket}
        >
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      {securitiesListedOnSecurityMarket && (
        <Form.Item
          name="listedOnSecurityMarket"
          label={qt('questionnaire.specifyStockExchange')}
          style={{ marginBottom: '15px' }}
        >
          <Input.TextArea rows={2} />
        </Form.Item>
      )}

      <Form.Item
        label={qt('questionnaire.areSecuritiesReputable')}
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group
          onChange={(e) => setSecuritiesListedOnReputableMarket(e.target.value)}
          value={securitiesListedOnReputableMarket}
        >
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      {securitiesListedOnReputableMarket && (
        <Form.Item
          name="listedOnReputableMarket"
          label={qt('questionnaire.specifyStockReputable')}
          style={{ marginBottom: '15px' }}
        >
          <Input.TextArea rows={2} />
        </Form.Item>
      )}

      {/* Offshore and Foreign Entity Questions */}
      <Form.Item
        label={qt('questionnaire.isClientAppear')}
        name="anyOwnerOffShore"
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group>
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        label={qt('questionnaire.ifYesPrevious')}
        name="legalEntityWithComplexOwnership"
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group>
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        label={qt('questionnaire.isForeignLegalEntity')}
        name="isOwnerForeignLegalEntity"
        style={{ marginBottom: '15px' }}
      >
        <Radio.Group>
          <Radio value={true}>{qt('questionnaire.yes')}</Radio>
          <Radio value={false}>{qt('questionnaire.no')}</Radio>
        </Radio.Group>
      </Form.Item>
    </Card>
  );
}
